import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from '../../store/authStore';
import api from '../../services/api';

const Callback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken, setUser } = useAuthStore();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      // Handle error
      setTimeout(() => {
        navigate('/auth/login?error=' + error);
      }, 2000);
      return;
    }

    if (token) {
      // Store token
      setToken(token);

      // Fetch user profile
      api
        .get('/api/auth/me')
        .then((response) => {
          setUser(response.data.data);
          navigate('/dashboard');
        })
        .catch((error) => {
          console.error('Failed to fetch user:', error);
          navigate('/auth/login?error=fetch_user_failed');
        });
    } else {
      navigate('/auth/login?error=no_token');
    }
  }, [searchParams, navigate, setToken, setUser]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#121212',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <Spin size="large" />
        <p style={{ color: '#BFBFBF', marginTop: '16px' }}>Completing login...</p>
      </div>
    </div>
  );
};

export default Callback;

